"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTumblrMonoDark = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("g", __assign({ clipPath: "url(#a)" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M14.6 24c-3.6 0-6.3-1.85-6.3-6.3v-7.1H5V6.75C8.6 5.8 10.1 2.7 10.3 0h3.75v6.1h4.35v4.5h-4.35v6.2c0 1.85.95 2.5 2.45 2.5h2.1V24h-4Z", fill: "#808597" }) })), (0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsx)("clipPath", __assign({ id: "a" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: "#fff", transform: "translate(5)", d: "M0 0h13.6v24H0z" }) })) })] }))); };
exports.default = SvgTumblrMonoDark;
